<template>
  <div>
    <vs-prompt
      title="Add new campaign"
      @cancel="val = ''"
      @accept="accept"
      @close="close"
      :active.sync="prompt"
      accept-text="Add"
      :is-valid="validForm"
      class="todoPopup"
    >
      <vs-row>
        <vs-col vs-w="12">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Title</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vx-tooltip
                text="This will be the title of this form. It can be changed later."
                position="bottom"
              >
                <vs-input
                  class="inputx w-full"
                  placeholder="Example: Summer campaign form"
                  v-model="title"
                />
              </vx-tooltip>
            </div>
          </div>
        </vs-col>
      </vs-row>
    </vs-prompt>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      title: "",
      prompt: false,
    };
  },
  computed: {
    validForm() {
      return this.title !== "";
    },
  },
  methods: {
    show() {
      this.title = "";
      this.prompt = true;
    },
    async accept() {
      const dto = {
        title: this.title,
      };

      this.$vs.loading();

      await this.$store.dispatch("dynamicForms/create", dto);

      this.$vs.notify({
        color: "success",
        title: `Form added`,
        text: "Form added",
      });
      this.$vs.loading.close();
    },
    close() {},
  },
};
</script>

<style lang="scss" scoped>
</style>
